var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { File } from "./File";
export class TemporalCesopXmlFile {
  constructor(_data) {
    /**
     */
    __publicField(this, "CreatedBy");
    /**
     */
    __publicField(this, "FileInfo");
    /**
     */
    __publicField(this, "FileName");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "IsExpired");
    /**
     */
    __publicField(this, "Status");
    /**
     */
    __publicField(this, "ValidationError");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof TemporalCesopXmlFile
     */
    __publicField(this, "$type", "V1.Cesop.Periods.TemporalCesopXmlFile");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.CreatedBy = _data["CreatedBy"];
      if (_data["FileInfo"]) {
        const fileInfo_ = new File();
        this.FileInfo = fileInfo_.init(_data["FileInfo"]);
      }
      this.FileName = _data["FileName"];
      this.Id = _data["Id"];
      this.IsExpired = _data["IsExpired"];
      this.Status = TemporalCesopXmlFileStatus[_data["Status"]];
      this.ValidationError = _data["ValidationError"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["CreatedBy"] = this.CreatedBy;
    _data["FileInfo"] = this.FileInfo ? this.FileInfo.toJSON() : void 0;
    _data["FileName"] = this.FileName;
    _data["Id"] = this.Id;
    _data["IsExpired"] = this.IsExpired;
    _data["Status"] = TemporalCesopXmlFileStatus[this.Status];
    _data["ValidationError"] = this.ValidationError;
    return _data;
  }
}
export var TemporalCesopXmlFileStatus = /* @__PURE__ */ ((TemporalCesopXmlFileStatus2) => {
  TemporalCesopXmlFileStatus2["New"] = "New";
  TemporalCesopXmlFileStatus2["Uploaded"] = "Uploaded";
  TemporalCesopXmlFileStatus2["Processing"] = "Processing";
  TemporalCesopXmlFileStatus2["ValidationError"] = "ValidationError";
  TemporalCesopXmlFileStatus2["NoMatchingPeriod"] = "NoMatchingPeriod";
  TemporalCesopXmlFileStatus2["AlreadyRegisteredFile"] = "AlreadyRegisteredFile";
  TemporalCesopXmlFileStatus2["InvalidMessageStatus"] = "InvalidMessageStatus";
  TemporalCesopXmlFileStatus2["TechnicalError"] = "TechnicalError";
  return TemporalCesopXmlFileStatus2;
})(TemporalCesopXmlFileStatus || {});
